var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3228 11.0304L11.4263 13.9268C11.3287 14.0245 11.1704 14.0245 11.0728 13.9268L8.17631 11.0304C8.01881 10.8729 8.13041 10.6036 8.35311 10.6036L10.4995 10.6036L10.4995 2.75C10.4995 2.33578 10.8353 2 11.2495 2C11.6637 2 11.9995 2.33578 11.9995 2.75L11.9995 10.6036L14.146 10.6036C14.3687 10.6036 14.4802 10.8729 14.3228 11.0304Z",
    fill: "#7799A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67529 4.96961L4.57174 2.07321C4.66937 1.97551 4.82766 1.97551 4.92529 2.07321L7.82174 4.96961C7.97924 5.12711 7.86764 5.39641 7.64494 5.39641H5.49854V13.25C5.49854 13.6642 5.16275 14 4.74854 14C4.33433 14 3.99854 13.6642 3.99854 13.25V5.39641H1.85207C1.62934 5.39641 1.5178 5.12711 1.67529 4.96961Z",
    fill: "#7799A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.8ca699808334865b56ad24a0eb24b44e.svg";
export { ForwardRef as ReactComponent };